import { useEffect, useState } from "react";
import { apiPatch } from "./api";
import { withRussianPrefix } from "./phone";
import { Disclosure, Kv } from "./Disclosure";

// Personal card of the account: the dispatcher calls this phone on SOS, so it
// lives on the account and is edited here, not in every order.
const AccountCard = ({ me, refreshMe, onError, onNotice, open, onToggle }) => {
  const user = me?.user;
  const [editing, setEditing] = useState(false);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", bio: "" });

  const fill = () =>
    setForm({
      name: user?.name ?? "",
      phone: user?.phone ?? "",
      bio: user?.bio ?? "",
    });

  useEffect(() => {
    if (user) fill();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const save = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      const payload = { name: form.name.trim() };
      if (form.phone.trim()) payload.phone = withRussianPrefix(form.phone.trim());
      payload.bio = form.bio.trim();
      await apiPatch("/api/user/me", payload);
      await refreshMe();
      setEditing(false);
      onNotice?.("Данные сохранены");
    } catch (err) {
      onError?.(err.message);
    } finally {
      setBusy(false);
    }
  };

  if (!user) return null;

  return (
    <Disclosure
      id="cab-profile"
      icon="cabinet"
      title="Профиль"
      hint={user.phone ?? "Телефон не указан"}
      tone={user.phone ? undefined : "danger"}
      open={open}
      onToggle={onToggle}
    >
      {editing ? (
        <form className="flex flex-col gap-2" onSubmit={save}>
          <div>
            <label className="taxi-field-label" htmlFor="account-name">Имя</label>
            <input
              id="account-name"
              className="taxi-field"
              value={form.name}
              required
              onChange={(event) => setForm({ ...form, name: event.target.value })}
            />
          </div>
          <div>
            <label className="taxi-field-label" htmlFor="account-phone">Телефон для связи</label>
            <input
              id="account-phone"
              className="taxi-field"
              type="tel"
              inputMode="tel"
              placeholder="+7 902 111-22-33"
              value={form.phone}
              onChange={(event) => setForm({ ...form, phone: event.target.value })}
            />
            <div className="taxi-field-label mt-1 mb-0">
              По этому номеру звонит диспетчер. Водителю он не показывается.
            </div>
          </div>
          <div>
            <label className="taxi-field-label" htmlFor="account-bio">О себе</label>
            <input
              id="account-bio"
              className="taxi-field"
              maxLength={100}
              placeholder="Короткая строка для других участников"
              value={form.bio}
              onChange={(event) => setForm({ ...form, bio: event.target.value })}
            />
          </div>
          <div className="taxi-acc-actions">
            <button
              type="button"
              className="taxi-btn flex-1"
              onClick={() => {
                fill();
                setEditing(false);
              }}
            >
              Отмена
            </button>
            <button type="submit" className="taxi-btn is-accent flex-1" disabled={busy}>
              {busy ? "Сохраняем…" : "Сохранить"}
            </button>
          </div>
        </form>
      ) : (
        <>
          <Kv label="Логин" value={user.username} />
          <Kv label="Телефон" value={user.phone} tone={user.phone ? undefined : "danger"} />
          <Kv label="О себе" value={user.bio} />
          <div className="taxi-acc-actions">
            <button
              type="button"
              className="taxi-btn"
              onClick={() => {
                fill();
                setEditing(true);
              }}
            >
              Изменить
            </button>
          </div>
        </>
      )}
    </Disclosure>
  );
};

export default AccountCard;
